import {
    InitiateDepositRequest,
    PaymentMethod,
    PaymentTransaction,
    UpiTransactionResponse,
} from '../../proto/generated/payments'
import api from './axiosClient'

const protobufHeaders = {
    Accept: 'application/x-protobuf',
}

export const initiateDeposit = async (params: {
    tradingAccountId: string
    amount: string
    paymentMethod?: PaymentMethod
}): Promise<UpiTransactionResponse> => {
    const body = InitiateDepositRequest.create({
        tradingAccountId: params.tradingAccountId,
        amount: params.amount,
        paymentMethod: params.paymentMethod ?? PaymentMethod.UPI,
    })
    const response = await api.post('/payments/deposit', JSON.stringify(InitiateDepositRequest.toJSON(body)), {
        headers: protobufHeaders,
        responseType: 'arraybuffer',
    })
    return UpiTransactionResponse.decode(new Uint8Array(response.data))
}
export const getPaymentTransactionStatus = async (
    transactionId: string
): Promise<PaymentTransaction> => {
    const response = await api.get(`/payments/transactions/${transactionId}`, {
        headers: {
            ...protobufHeaders,
            'X-Suppress-Error': 'true',
        },
        responseType: 'arraybuffer',
    })
    return PaymentTransaction.decode(new Uint8Array(response.data))
}
export const getUpiIntent = async (transactionId: string): Promise<UpiTransactionResponse> => {
    const response = await api.get(`/payments/transactions/${transactionId}/upi-intent`, {
        headers: {
            ...protobufHeaders,
            'X-Suppress-Error': 'true',
        },
        responseType: 'arraybuffer',
    })
    return UpiTransactionResponse.decode(new Uint8Array(response.data))
}
